/* eslint-disable */
/* eslint-disable no-unused-vars */

import styled from 'styled-components';
import { FiSearch, FiX, FiChevronDown, FiChevronUp } from 'react-icons/fi';

export const FAQContainer = styled.div`
  max-width: 90%;
  margin: 20px auto;
  padding: 20px;
  font-family: Arial, sans-serif;
`;

export const FAQHeader = styled.div`
  margin-bottom: 20px;
`;

export const FAQTitle = styled.h1`
  font-size: 20px;
  margin-bottom: 5px;
`;

export const FAQSubtitle = styled.p`
  color: #666;
  font-size: 1rem;
`;

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  position: relative;
`;

export const SearchBox = styled.div`
  position: relative;
  width: 100%;
  max-width: 400px;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 10px 40px 10px 40px;
  font-size: 1rem;
  border-radius: 4px;
  border: 1px solid #ccc;
  &:focus {
    outline: none;
    border-color: #007bff;
  }
`;

export const SearchIcon = styled(FiSearch)`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #999;
`;

export const ClearSearchButton = styled.button`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: #999;
  cursor: pointer;
  font-size: 1.2rem;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CategoryFilter = styled.div`
  margin-bottom: 20px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;

export const CategoryButton = styled.button<{ active: boolean }>`
  padding: 8px 16px;
  font-size: 0.9rem;
  border-radius: 20px;
  border: none;
  cursor: pointer;
  background-color: ${({ active }) => (active ? '#007bff' : '#eee')};
  color: ${({ active }) => (active ? '#fff' : '#333')};
  transition: background-color 0.3s ease;
  &:hover {
    background-color: ${({ active }) => (active ? '#0056b3' : '#ccc')};
  }
`;

export const FAQContent = styled.div`
  border-top: 1px solid #ddd;
`;

export const FAQCategoryWrapper = styled.div`
  margin-bottom: 20px;
`;

export const FAQCategoryTitle = styled.h3`
  font-size: 1.2rem;
  margin-bottom: 10px;
`;

export const RightHeader = styled.div`
  width: 60%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  max-height: auto;
`;

export const PageTitle = styled.h1`
  font-size: 3rem;
  color: #1a1a32;
  font-weight: 600;
  margin-bottom: 20px;
`;

export const ScreenHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

export const ModalContainer = styled.div`
  background-color: white;
  padding: 30px;
  border-radius: 8px;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  text-align: center;

  h3 {
    font-size: 1.6rem;
    margin-bottom: 16px;
  }

  p {
    font-size: 1.2rem;
    color: #444;
  }

  .modal-actions {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin-top: 20px;
  }
`;

export const FAQItem = styled.div`
  background: #fff;
  border: 1px solid #e1e1e1;
  border-radius: 12px;
  margin-bottom: 15px;
  overflow: hidden;
  transition: all 0.3s ease;

  &.active .faq-icon {
    transform: rotate(45deg); /* like + → × */
  }
`;

export const FAQQuestion = styled.div`
  padding: 20px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background 0.3s ease;

  &:hover {
    background: rgba(74, 144, 226, 0.05);
  }

  h3 {
    font-size: 20px;
    color: #2d3436;
    margin: 0;
    flex-grow: 1; /* Take all remaining space */
  }
`;

// New wrapper for icons container aligned right
export const FAQActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const FAQAnswer = styled.div`
  padding: 0 20px 20px;
  font-size: 18px;
  color: #636e72;
`;

export const FAQIcon = styled.span`
  font-size: 1.2rem;
  color: #4a90e2;
  transition: transform 0.3s ease;
  display: flex;
  align-items: center;
`;
